<template>
  <layout-basic>
    <page-hero
      title="Guides"
      lead="Practical guides to help you build a better learning culture."
    />

    <section class="resource-shell">
      <v-container>
        <p class="resource-shell__note">
          New guides are being prepared. In the meantime, explore our blog or
          watch the demo to see how IMPROVE helps growing businesses learn.
        </p>
      </v-container>
    </section>

    <point-grid :points="points" :columns="2" tint />
    <standard-cta />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PageHero from '@/components/marketing/PageHero.vue';
import PointGrid from '@/components/marketing/PointGrid.vue';
import StandardCta from '@/components/marketing/StandardCta.vue';
import { marketingPageMeta } from '@/utils/marketingPage';

export default {
  name: 'Guides',
  components: {
    LayoutBasic,
    PageHero,
    PointGrid,
    StandardCta,
  },
  metaInfo() {
    return marketingPageMeta({
      title: 'Guides | IMPROVE',
      description: 'Practical guides to help you build a better learning culture.',
      path: '/resources/guides',
    });
  },
  data() {
    return {
      points: [
        'How to onboard new starters consistently',
        'How to keep compliance training organised',
        'How to develop managers without complexity',
        'How to build a simple learning culture',
      ],
    };
  },
};
</script>

<style scoped>
.resource-shell {
  padding: 8px 0 24px;
}

.resource-shell__note {
  text-align: center;
  max-width: 560px;
  margin: 0 auto 8px;
  color: var(--brand-grey, #6b7280);
  font-size: 15px;
  line-height: 1.5;
}
</style>
